import {
  createAccountSpaceIndexApi,
  createFetchTransport,
  createWakeLoopApiClient,
  resolveAccountSpaceIndexGatewayHost,
} from "@wakeloop/api-client";
import type {
  AccountSpaceIndexResponse,
  WakeLoopRequestContext,
} from "@wakeloop/schemas/types";
import { buildWakeLoopRequestContextHeadersWithAuth } from "./request-headers";

const ACCOUNT_SPACE_INDEX_TIMEOUT_MS = 10_000;

export async function listAccountSpaceIndex(input: {
  baseUrl: string;
  requestContext: WakeLoopRequestContext;
  includePurposes?: boolean;
  limit?: number;
  scope: "account" | "profile";
  selectedProfileId: string;
}): Promise<AccountSpaceIndexResponse> {
  return await createAccountSpaceIndexApi(
    createWakeLoopApiClient({
      baseUrl: input.baseUrl,
      transport: createFetchTransport({
        fetch,
        defaultTimeoutMs: ACCOUNT_SPACE_INDEX_TIMEOUT_MS,
      }),
      getRequestContextHeaders: async ({ requestUrl, requestContext }) =>
        await buildWakeLoopRequestContextHeadersWithAuth({
          requestUrl,
          requestContext,
        }),
    })
  ).listAccountSpaces({
    requestContext: input.requestContext,
    gatewayHost: resolveAccountSpaceIndexGatewayHost(input.baseUrl),
    ...(input.includePurposes === true ? { includePurposes: true } : {}),
    ...(input.limit === undefined ? {} : { limit: input.limit }),
    scope: input.scope,
    selectedProfileId: input.selectedProfileId,
    timeoutMs: ACCOUNT_SPACE_INDEX_TIMEOUT_MS,
  });
}
